import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";

// La vista Home se carga de forma eager (es la ruta inicial / landing).
// El resto se cargan con lazy-loading para reducir el bundle inicial.
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/price",
    name: "price",
    component: () => import("@/views/PriceView.vue"),
  },
  {
    path: "/services/:id?",
    name: "services",
    component: () => import("@/views/ServicesView.vue"),
  },
  {
    path: "/plugins/:id?",
    name: "plugins",
    component: () => import("@/views/PluginsView.vue"),
  },
  {
    path: "/policy/:linkName",
    name: "policy",
    component: () => import("@/views/LegalView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

export default router;
